import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import services2 from "../src/assets/interest.jpg"
import "./Menu1.css";

const InterestRates = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const interestRates = [
    { duration: "30 days to 45 days", rate: "5.25%" },
    { duration: "46 days to 90 days", rate: "5.75%" },
    { duration: "91 days to 179 days", rate: "6.75%" },
    { duration: "180 days to 364 days", rate: "7.50%" },
    { duration: "One year", rate: "8.60%" },
    { duration: "400 Days", rate: "9.10%" },
    { duration: "1000 Days", rate: "8.60%" },
    { duration: "13 months to 60 months", rate: "7.75%" },
    { duration: "61 months to 120 months", rate: "7.50%" },
    { duration: "Saraswathi Cash Certificate 12 months", rate: "8.50%" },
    { duration: "Saraswathi Cash Certificate 13 months- 35 months", rate: "7.65%" },
    { duration: "Nithyanidhi (Pigmy Account)", rate: "3%" },
    { duration: "Savings Account", rate: "3%" },
    { duration: "RD interest (1 year)", rate: "8.6%" },
    { duration: "RD interest (Above 1 year to 5 years)", rate: "7.75%" },
    { duration: " RD interest (Above 5 year to 10 years)", rate: "7.50%" },
  ];

  // Responsive styles
  const containerStyle = {
    maxWidth: isMobile ? "95%" : "800px",
    margin: isMobile ? "10px auto" : "20px auto",
    padding: isMobile ? "10px" : "20px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#fff",
  };

  const headerStyle = {
    textAlign: "center",
    backgroundColor: "#880e4f",
    color: "#fff",
    padding: isMobile ? "8px 5px" : "10px 0",
    borderRadius: "8px 8px 0 0",
    fontSize: isMobile ? "16px" : "18px",
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
    fontSize: isMobile ? "12px" : "14px",
  };

  const thStyle = {
    textAlign: "left",
    padding: isMobile ? "8px 5px" : "10px",
    backgroundColor: "#f5f5f5",
    borderBottom: "2px solid #ddd",
    fontSize: isMobile ? "12px" : "14px",
  };

  const thRightStyle = {
    ...thStyle,
    textAlign: "right",
  };

  const tdStyle = (index) => ({
    padding: isMobile ? "8px 5px" : "10px",
    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
    borderBottom: "1px solid #ddd",
    fontSize: isMobile ? "11px" : "14px",
    wordBreak: isMobile ? "break-word" : "normal",
  });

  const noteStyle = {
    marginTop: isMobile ? "15px" : "20px",
    backgroundColor: "#fce4ec",
    padding: isMobile ? "8px" : "10px",
    borderRadius: "5px",
    border: "1px solid #f8bbd0",
    fontSize: isMobile ? "12px" : "14px",
    lineHeight: isMobile ? "1.4" : "1.6",
  };

  const bannerImageStyle = {
    width: "100%",
    height: isMobile ? "180px" : "340px",
    objectFit: "cover",
  };

  return (
    <div style={{ background: "linear-gradient(90deg, #fff, #cb71ca)" }}>
      <Navbar/>
      
      {/* Mobile Menu Toggle Button */}
      {isMobile && (
        <div className="mobile-menu-toggle" onClick={toggleSidebar}>
          <div className={`hamburger ${sidebarOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar}></div>
      )}

      <div className={`small-container ${isMobile ? 'mobile' : ''}`} style={{gap: isMobile ? "0px" : "5px"}}>
        {/* Sidebar */}
        <div className={`small-sidebar ${isMobile ? (sidebarOpen ? 'mobile-open' : 'mobile-closed') : ''}`}>
          {/* Top wave */}
          <div className="sidebar-wave-top"></div>
          <ul>
            <li>
              <a href="presidents_message" onClick={isMobile ? closeSidebar : undefined}>President's Message</a>
            </li>
            <li><a href="documents" onClick={isMobile ? closeSidebar : undefined}>Annual Report</a></li>
            <li><a href="interest" onClick={isMobile ? closeSidebar : undefined}>Interest Rate</a></li>
            <li><a href="loans" onClick={isMobile ? closeSidebar : undefined}>Loans</a></li>
            <li><a href="awards" onClick={isMobile ? closeSidebar : undefined}>Awards</a></li>
          </ul>
          {/* Bottom wave */}
          <div className="sidebar-wave"></div>
        </div>

        {/* Content Section */}
        <div className="small-content">
          <div className="image-wrapper">
            <img src={services2} alt="About Us" style={bannerImageStyle} />
          </div>
        </div>
      </div>

      <div style={containerStyle}>
        <h2 style={headerStyle}>
          Attractive Interest Rates on Deposits
        </h2>
        <div style={{ overflowX: isMobile ? "auto" : "visible" }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>
                  Duration
                </th>
                <th style={thRightStyle}>
                  Interest Rate
                </th>
              </tr>
            </thead>
            <tbody>
              {interestRates.map((item, index) => (
                <tr key={index} style={{textAlign:"justify"}}>
                  <td style={tdStyle(index)}>
                    {item.duration}
                  </td>
                  <td style={{...tdStyle(index), textAlign: "right"}}>
                    {item.rate}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p style={noteStyle}>
          <strong>Note:</strong> Special 0.4% extra interest for 1 year and above
          deposits for Senior citizens, Physically challenged, Widows, Soldiers,
          and other institutions.
        </p>
      </div>
      <Footer/>
    </div>
  );
};

export default InterestRates;